import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { useTranslation } from "react-i18next";
import cx from "classnames";
import SubMenuItem from "../SubMenuItem";

const EarnMenu = ({ isActive, siteCountry }) => {
  const { t } = useTranslation();

  const data = useStaticQuery(graphql`
    query {
      ...EarnMenuIcons
    }
  `);

  return (
    <div
      id="sub-menu__earn"
      className={cx(
        "container sub-menu sub-menu__earn row",
        { active: isActive },
        { inactive: !isActive }
      )}
    >
      <div className="col-4">
        <SubMenuItem
          title={t("menu.earn.zipup.title")}
          description={t("menu.earn.zipup.description")}
          imageSrc={data.zipupIcon.publicURL}
          linkTo={`/earn/`}
        />
      </div>
      <div className="col-4">
        <SubMenuItem
          title={t("menu.earn.zmt.title")}
          description={t("menu.earn.zmt.description")}
          imageSrc={data.zmtIcon.publicURL}
          linkTo={`/zmt/`}
        />
      </div>
      <div className="col-4">
        <SubMenuItem
          title={t("menu.earn.zlaunch.title")}
          description={t("menu.earn.zlaunch.description")}
          imageSrc={data.zlaunchIcon.publicURL}
          linkTo={`/zlaunch/`}
        />
      </div>
    </div>
  );
};

export default EarnMenu;
